import {
  ADD_OWNER,
  UPDATE_OWNER,
  REMOVE_OWNER,
  SUBMIT_OWNERSHIP,
  SUBMIT_OWNERSHIP_COMPLETED
} from '../actions/ownership';

import {
  GET_APPLICATION_COMPLETE
} from '../actions/onboarding';

const defaultState = [
  { address: {}, type: 'OWNER' }
];

const OWNER_CONTROLLER = 'OWNER_AND_CONTROLLER';

export default (state = defaultState, action) => {
  switch (action.type) {
    case ADD_OWNER: {
      let owners = [...state ];
      owners.push({ address: {}, type: 'OWNER' });
      return owners;
    }
    case UPDATE_OWNER: {
      let owners = [...state];
      const { index, field, value, errors } = action;
      const owner = { ...owners[index], errors };
      if (field) {
        if (field.indexOf('.') !== -1) {
          const [topField, subField] = field.split('.');
          owner[topField][subField] = value;
        } else {
          owner[field] = value;
        }
      }
      owner.triggerValidation = false;
      owners[index] = owner;
      return owners;
    }
    case REMOVE_OWNER: {
      let owners = [...state];
      owners.pop();
      return owners;
    }
    case 'SELECT_CONTROLLER': {
      const owners = [...state];
      const controllerIdx = owners.findIndex((owner) => {
        return owner.type === OWNER_CONTROLLER;
      });

      if (controllerIdx !== -1) {
        owners[controllerIdx].type = 'OWNER';
      }

      if (owners[action.index]) {
        owners[action.index].type = OWNER_CONTROLLER;
      }

      return owners;
    }
    case SUBMIT_OWNERSHIP_COMPLETED: {
      const { payload } = action;
      if (payload && payload.owners) {
        return [...payload.owners];
      }
      return state;
    }
    case GET_APPLICATION_COMPLETE:
      const { owners } = action.payload;
      return [...owners];
    case SUBMIT_OWNERSHIP:
      const { triggerValidations } = action;
      return state.map((owner) => ({...owner, triggerValidation: triggerValidations }));
    default:
     return state;
  }
};

